<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreateTicket', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <SuggestUsersRole
              v-model="ItemForm.User"
              :error-messages="errors.User"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Užívateľ"
              role="ROLE_WORKER"
              :createButton="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.amount"
              :error-messages="errors.amount"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Výška"
              type="number"
              suffix="%"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.note"
              :error-messages="errors.note"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Poznámka"
              :rows="5"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import TicketShares from '@/services/ticket-shares'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  import SuggestUsersRole from '@/components/Users/SuggestRole'

  export default {
    name: 'CreateTicket',
    props: [
      'ticketId'
    ],
    emits: [
      'onCreateTicket'
    ],
    components: {
      CreateSave,
      SuggestUsersRole
    },
    methods: {
      setTitle() {
        return 'Vytvoriť podiel'
      },
      setItemForm() {
        return {
          User: null,
          amount: 0,
          note: null
        }
      },
      createData(ItemForm) {
        return TicketShares
          .createTicket({
            ticketId: this.ticketId,
            data: ItemForm
          })
      }
    }
  }
</script>
